// Reusable link-URL validator. Mirrors the backend format check
// (gandalf JourneyFacadeController LINK_URL_PATTERN) so the client warns on the
// same inputs the API would reject for format. Reachability is NOT checked here
// (backend concern; treated as a non-blocking warning per ch60352).
const LINK_URL_PATTERN = /^https?:\/\/[^\s/$.?#][^\s]*$/i;

/** True when the URL is empty (no link) or a well-formed http(s) URL. */
export function isValidLinkUrl(url) {
  if (url == null || url === '') return true;
  return LINK_URL_PATTERN.test(url);
}
